import { render, staticRenderFns } from "./AddressCurrent.vue?vue&type=template&id=0a7ceffc"
import script from "./AddressCurrent.vue?vue&type=script&lang=js"
export * from "./AddressCurrent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports